<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<nav class="navbar flex justify-content-between align-items-center">
  <figure class="hd_logo" style="cursor: pointer">
    <img
      [ngSrc]="assetsConst.headerLogo"
      (click)="gotoHome()"
      alt="logibids-logo"
      width="360"
      height="86"
      fetchpriority="high"
      priority />
    <img
      class="mob_logo"
      [ngSrc]="assetsConst.logomini"
      (click)="gotoHome()"
      alt="logibids-logo"
      width="80"
      height="80"
      fetchpriority="high"
      priority />
  </figure>
  <ul class="nav_rt flex align-items-center justify-content-end">
    @if (user()) {
      <li #notificationButton class="nav-item dropdown relative mr_6" id="notificationStep">
        <a
          class="nav-link dropdown-toggle hover-hand user-icon clr"
          href="javascript:void(0);"
          role="button"
          aria-label="Toggle notifications"
          (click)="toggleLazyOverlay($event, 'op', notificationButton)">
          <figure class="notification_icon">
            <img [ngSrc]="assetsConst.bell" width="16" height="20" alt="photo" priority />
          </figure>
          @if (user() && user().notification_unread) {
            <p>{{ user().notification_unread }}</p>
          }
        </a>
      </li>
      @if (translateService) {
        <li class="nav-item dropdown mr_6" (click)="toggleLazyOverlay($event, 'op2')">
          <a
            class="nav-link dropdown-toggle hover-hand user-icon blacktext"
            role="button"
            aria-label="Change language">
            <figure
              style="
                position: relative !important;
                top: 0.4vh !important;
                width: 30px;
                height: 30px;
              ">
              <img [ngSrc]="assetsConst.globe" width="25" height="25" priority alt="globe" />
            </figure>
            <p>{{ selectedLang() }}</p>
          </a>
        </li>
      }

      <!-- <li class="nav-item dropdown mr_6" (click)="op3.toggle($event)">
        <a
          class="nav-link dropdown-toggle hover-hand user-icon clr"
          role="button">
          <figure>
            <img
              [ngSrc]="assetsConst.iicon"
              width="25"
              height="25"
              alt="iicon"
              priority />
          </figure>
        </a>
      </li> -->

      <li
        class="nav-item dropdown user_profile"
        id="SettingsStep"
        (click)="toggleLazyOverlay($event, 'op1')">
        <a class="nav-link dropdown-toggle hover-hand user-icon user_cl" role="button">
          <figure>
            @if (user()?.photo) {
              <img
                [ngSrc]="user()?.photo ?? assetsConst.user"
                width="25"
                height="25"
                priority
                alt="photo" />
            }
          </figure>
        </a>
      </li>

      <li class="mid_streme">
        <ul>
          <li
            id="ImmediateStep"
            class="nav-item dropdown mr_6"
            routerLink="/delivery/enquiry-listing"
            style="cursor: pointer; margin: 0">
            <a class="nav-link dropdown-toggle hover-hand user-icon clr">
              <figure class="emmidate_icon">
                <img
                  [ngSrc]="assetsConst.countdown"
                  width="25"
                  height="25"
                  alt="countdown"
                  priority />
              </figure>
            </a>
          </li>
          <li
            id="scheduleStep"
            class="nav-item dropdown"
            routerLink="/schedule-rent-transport/listingenquiry"
            style="cursor: pointer; margin: 7px">
            <a class="nav-link dropdown-toggle hover-hand user-icon clr">
              <figure class="schedule_icon">
                <img
                  [ngSrc]="assetsConst.hammer"
                  width="25"
                  height="25"
                  alt="hammer"
                  priority />
              </figure>
            </a>
          </li>
        </ul>
      </li>

      @if (hasPrefrences()) {
        <li class="nav-item dropdown extra" style="cursor: pointer">
          <a
            type="button"
            class="nav-link dropdown-toggle hover-hand user-icon clr"
            (click)="hidePrefernces()">
            {{ 'Extra' | translate }}
            <span
              ><img [ngSrc]="assetsConst.plus" width="25" height="25" alt="plus" priority
            /></span>
          </a>
          <logibids-prefrences
            [prefrencesValue]="prefrences()"
            (hidePrefernces)="hidePrefernces($event)"
            [prefrences]="prefrencesData()"></logibids-prefrences>
        </li>
      }
    }
  </ul>
</nav>

@if (isOpInitialized()) {
  <p-overlayPanel
    #op
    class="notification_menu"
    appendTo="body"
    (onHide)="onOverlayHide('op')"
    [style]="{
      width: '426px',
    }">
    <div class="mn_notification">
      <div class="title" style="font-weight: 600; font-size: 20px">
        <h4>{{ 'Notifications' | translate }}</h4>
      </div>
      <ngx-ui-loader
        loaderId="notificationLoader"
        [overlayColor]="'rgba(255,255,255,0.8)'"
        blur="13"
        [bgsOpacity]="0.1"
        fgsType="circle"
        fgsColor="#000000"
        [hasProgressBar]="false" />
      @if (notifications() && notifications().length > 0) {
        <div class="notification-item1">
          <ul
            class=""
            infiniteScroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="50"
            [scrollWindow]="false"
            (scrolled)="onScrollingFinished()">
            @for (list of notifications(); track $index; let index = $index) {
              <li
                [class.notifiViewd]="list.viewed === true"
                [class.border_rt]="isTripEndedNotification(list)"
                (click)="
                  btn_routeNotification(
                    list.payload.type,
                    list.payload.enquiry_id,
                    list.id,
                    list.payload
                  )
                ">
                @if (!list.viewed) {
                  <div class="dot"></div>
                } @else {
                  <div class="Withoutdot"></div>
                }
                <p [class.border_rt]="isTripEndedNotification(list)">
                  {{ getFormattedMessage(list.message) }}
                  <span class="block">
                    <bdi>
                      {{ list.created_at | date: 'dd-MM-YYYY hh:mm:ss a' }}
                    </bdi>
                  </span>
                </p>
                @if (isTripEndedNotification(list)) {
                  <div class="ar_rting_wrp">
                    <div class="userRating">
                      @if (list.rating === null) {
                        <figure style="text-align: center">
                          <img
                            [ngSrc]="assetsConst.sadSmile"
                            alt="sadSmile"
                            width="100"
                            height="100"
                            priority
                            style="width: 50px; height: 47px" />
                        </figure>
                        <p>{{ 'notRated' | translate }}</p>
                      } @else if (list.rating && list.rating !== null) {
                        <p>{{ 'Yourrating' | translate }}</p>

                        <logibids-stars
                          class="custom-stars"
                          [readonly]="true"
                          [color]="'#efbf04'"
                          [maxStars]="5"
                          [initialStars]="list.rating" />
                      }
                    </div>
                  </div>
                }
              </li>
            }
          </ul>
        </div>
      } @else if (notifications() && notifications().length === 0) {
        <div class="noDataFound">
          <figure>
            <img
              [ngSrc]="assetsConst.noNotification"
              alt="noNotification"
              width="234"
              height="206"
              priority />
          </figure>
          <p>
            {{ 'noNotifications' | translate }}
          </p>
        </div>
      }
    </div>
  </p-overlayPanel>
}
@if (isOp1Initialized()) {
  <p-overlayPanel
    #op1
    class="header_op"
    appendTo="body"
    (onHide)="onOverlayHide('op1')"
    [style]="{
      width: '370px',
      'overflow-y': 'scroll',
      'scroll-behavior': 'smooth',
    }"
    infiniteScroll
    [infiniteScrollDistance]="20"
    [infiniteScrollThrottle]="20"
    [scrollWindow]="false">
    <ul class="profile_drpdwn main_profile_wrapper">
      <div
        class="title"
        style="font-weight: 600; font-size: 20px; margin-top: 1px; text-align: left">
        <h4>{{ 'my_account' | translate }}</h4>
      </div>
      <li (click)="gotoMyProfile()">
        <figure>
          <img [ngSrc]="assetsConst.sidebar1" alt="svg" width="20" height="20" priority />
        </figure>
        <a class="dropdown-item hover-hand newClr">{{ 'myProfile' | translate }} </a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>
      <li (click)="gotoMyTrips()">
        <figure>
          <img [ngSrc]="assetsConst.sidebar5" alt="svg" width="20" height="20" priority />
        </figure>
        <a class="dropdown-item hover-hand newClr">{{ 'myTrips' | translate }} </a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>

      @if (user() && user().default_region && user().default_region.is_loyalty_active === true) {
        <li (click)="goToLoyality()">
          <figure>
            <img [ngSrc]="assetsConst.loyalty" alt="svg" width="20" height="20" priority />
          </figure>
          <a class="dropdown-item hover-hand newClr">{{ 'LoyaltyProgram' | translate }} </a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
      }
      @if (user() && user().default_region && user().default_region.is_referral_active === true) {
        <li (click)="goToRefer()">
          <figure>
            <img [ngSrc]="assetsConst.referSidebar" alt="svg" width="20" height="20" priority />
          </figure>
          <a class="dropdown-item hover-hand newClr">{{ 'ReferEarn' | translate }} </a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
      }

      <li (click)="goToMyWallet()">
        <figure>
          <img [ngSrc]="assetsConst.sidebar11" alt="svg" width="20" height="20" priority />
        </figure>
        <a class="dropdown-item hover-hand newClr">{{ 'Wallet' | translate }} </a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>

      <ngx-ui-loader
        loaderId="uniqueLoader2"
        style="margin-bottom: -11px"
        [overlayColor]="'rgba(255,255,255,0.8)'"
        blur="13"
        [bgsOpacity]="0.1"
        fgsType="circle"
        fgsColor="#000000"
        [hasProgressBar]="false" />

      <li (click)="gotoChangePassword()">
        <figure>
          <img [ngSrc]="assetsConst.sidebar7" alt="svg" width="20" height="20" priority />
        </figure>
        <a class="dropdown-item hover-hand newClr">{{ 'changePass' | translate }}</a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>
      <li (click)="deleteUser()">
        <figure>
          <img [ngSrc]="assetsConst.accountControl" alt="svg" width="20" height="20" priority />
        </figure>
        <a class="dropdown-item hover-hand newClr">{{ 'accountControl' | translate }}</a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>
      <li>
        <figure>
          <img [ngSrc]="assetsConst.sidebar10" alt="svg" width="20" height="20" priority />
        </figure>
        <a
          class="dropdown-item hover-hand header-switch newClr"
          style="display: flex; justify-content: space-between; gap: 20px">
          {{ 'Notifications' | translate }}
          <p-inputSwitch
            [(ngModel)]="notification"
            class="float-right height-0"
            (onChange)="notificationOnOff($event)"></p-inputSwitch>
        </a>
      </li>
      <li>
        <figure>
          <img [ngSrc]="assetsConst.autoPayment" alt="svg" width="20" height="20" priority />
        </figure>
        <a
          class="dropdown-item hover-hand header-switch newClr"
          style="display: flex; justify-content: space-between; gap: 20px">
          {{ 'AutoPayment' | translate }}
          <p-inputSwitch
            [(ngModel)]="is_auto_pay"
            class="float-right height-0"
            (onChange)="autoPaymentOnOff($event)"></p-inputSwitch>
        </a>
      </li>
    </ul>
    <ul class="profile_drpdwn main_profile_wrapper">
      <div
        class="title"
        style="font-weight: 600; font-size: 20px; margin-top: 1px; text-align: left">
        <h4>{{ 'logibids' | translate }}</h4>
      </div>
      <li>
        <figure>
          <img [ngSrc]="assetsConst.Vector1" alt="svg" width="20" height="20" priority />
        </figure>
        <a class="dropdown-item hover-hand newClr fnt" (click)="gotoAboutUs()">{{
          'aboutUs' | translate
        }}</a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>
      <li>
        <figure>
          <img [ngSrc]="assetsConst.Vector2" alt="svg" width="20" height="20" priority />
        </figure>
        <a class="dropdown-item hover-hand newClr fnt" (click)="gotoTerms()">{{
          'termsConditions' | translate
        }}</a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>
      <li>
        <figure>
          <img [ngSrc]="assetsConst.Vector3" alt="svg" width="20" height="20" priority />
        </figure>
        <a class="dropdown-item hover-hand newClr fnt" (click)="gotoPrivacy()">{{
          'privacyPolicy' | translate
        }}</a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>
      <li>
        <figure>
          <img [ngSrc]="assetsConst.contactCall" alt="svg" width="20" height="20" priority />
        </figure>
        <a class="dropdown-item hover-hand newClr fnt" (click)="gotoContact()">{{
          'contactUs' | translate
        }}</a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>

      <li>
        <figure>
          <img [ngSrc]="assetsConst.Faqs" alt="svg" width="20" height="20" priority />
        </figure>
        <a class="dropdown-item hover-hand newClr fnt" (click)="gotoFaq()">{{
          'Faqs' | translate
        }}</a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>
      <li>
        <figure>
          <img [ngSrc]="assetsConst.HelpGuide" alt="svg" width="20" height="20" priority />
        </figure>
        <a class="dropdown-item hover-hand newClr fnt" (click)="goToHelpGuide()">{{
          'HelpGuide' | translate
        }}</a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>
      <li (click)="openAI()">
        <figure>
          <img [src]="assetsConst.chatSupport" alt="svg" />
        </figure>
        <a class="dropdown-item hover-hand newClr fnt">{{ 'chatSupport' | translate }}</a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>
    </ul>
    <ul class="profile_drpdwn main_profile_wrapper">
      <div
        class="title"
        style="font-weight: 600; font-size: 20px; margin-top: 1px; text-align: left">
        <h4>{{ 'logout' | translate }}</h4>
      </div>
      <li (click)="btn_logOut()">
        <figure>
          <img [ngSrc]="assetsConst.sidebar9" alt="svg" width="20" height="20" priority />
        </figure>
        <a class="dropdown-item hover-hand newClr">{{ 'logout' | translate }}</a>
        <div class="arrow">
          <figure>
            <img [src]="assetsConst.headerArrow" alt="dsfds" />
          </figure>
        </div>
      </li>
    </ul>
  </p-overlayPanel>
}
@if (isOp2Initialized()) {
  <p-overlayPanel
    #op2
    class="header_op"
    appendTo="body"
    (onHide)="onOverlayHide('op2')"
    [style]="{
      width: '163px',
      'overflow-y': 'scroll',
      'scroll-behavior': 'smooth',
    }"
    infiniteScroll
    [infiniteScrollDistance]="20"
    [infiniteScrollThrottle]="20"
    [scrollWindow]="false">
    <div class="profile_drpdwn language_menu_wrapper">
      <div
        class="title"
        style="font-weight: 600; font-size: 20px; margin-top: 1px; text-align: center">
        <h4>{{ 'langugae' | translate }}</h4>
      </div>
      <ul class="language_list">
        @for (lang of filteredLanguages(); track $index) {
          <li>
            <figure>
              <img [ngSrc]="assetsConst.sidebar12" alt="svg" width="20" height="20" priority />
            </figure>
            <a class="dropdown-item hover-hand newClr" (click)="setLanguage(lang.language_code)">{{
              lang.name
            }}</a>
            <div class="arrow">
              <figure>
                <img [src]="assetsConst.headerArrow" alt="dsfds" />
              </figure>
            </div>
          </li>
        }
      </ul>
    </div>
  </p-overlayPanel>
}
@if (isOp3Initialized()) {
  <p-overlayPanel
    #op3
    class="header_op"
    appendTo="body"
    (onHide)="onOverlayHide('op3')"
    [style]="{
      width: '290px',
      'overflow-y': 'scroll',
      'scroll-behavior': 'smooth',
      left: '1000px !important',
    }"
    infiniteScroll
    [infiniteScrollDistance]="20"
    [infiniteScrollThrottle]="20"
    [scrollWindow]="false">
    <div class="profile_drpdwn">
      <div
        class="title"
        style="font-weight: 600; font-size: 20px; margin-top: 1px; text-align: center">
        <h4>{{ 'Logibids' | translate }}</h4>
      </div>
      <ul>
        <li>
          <figure>
            <img [ngSrc]="assetsConst.Vector1" alt="svg" width="20" height="20" priority />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt" (click)="gotoAboutUs()">{{
            'aboutUs' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        <li>
          <figure>
            <img [ngSrc]="assetsConst.Vector2" alt="svg" width="20" height="20" priority />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt" (click)="gotoTerms()">{{
            'termsConditions' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        <li>
          <figure>
            <img [ngSrc]="assetsConst.Vector3" alt="svg" width="20" height="20" priority />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt" (click)="gotoPrivacy()">{{
            'privacyPolicy' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        <li>
          <figure>
            <img [ngSrc]="assetsConst.contactCall" alt="svg" width="20" height="20" priority />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt" (click)="gotoContact()">{{
            'contactUs' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
        <li>
          <figure>
            <img [ngSrc]="assetsConst.Vector1" alt="svg" width="20" height="20" priority />
          </figure>
          <a class="dropdown-item hover-hand newClr fnt" (click)="gotoFaq()">{{
            'Faqs' | translate
          }}</a>
          <div class="arrow">
            <figure>
              <img [src]="assetsConst.headerArrow" alt="dsfds" />
            </figure>
          </div>
        </li>
      </ul>
    </div>
  </p-overlayPanel>
}
